// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"fea8a5e2","353":"636dbbc9","669":"fea8a5e2","787":"11b35d64","850":"c3db2301"}[chunkId] + ".chunk.js";
};